<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="peligroso.companyJob"
                            :items="$store.state.companyJobs"
                            label="Puesto de trabajo"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="peligroso.type"
                            :items="$store.state.types"
                            label="Tipos"
                            v-on:change="getElementsByType"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="peligroso.element"
                            :items="this.itemsElements"
                            label="Tipos de Elementos"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm4 offset-sm1>
                    <v-select
                            v-model="peligroso.value"
                            :items="this.itemsPeligrosos"
                            label="Valores"
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                    <div>
                        <v-btn :disabled="!valid"
                               @click="saveDataPeligroso" large color="primary">Guardar</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <v-data-table
                    :headers="headersPeligroso"
                    :items="this.$store.state.dangerousProcesses"
                    class="elevation-1"
                    sort-icon="mdi-menu-down"
                    :search="search"
            >
                <template slot="items" slot-scope="props" >
                    <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.companyJob.name }}</td>
                    <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.type.name }}</td>
                    <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.element.name }}</td>
                    <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.value }}</td>
                    <td class="text-xs-left" :style="getColor(props.item.value)">{{ props.item.date}}</td>
                    <td :style="getColor(props.item.value)">
                        <v-tooltip top >
                            <v-btn fab dark small @click="deleteItemPeligroso(props.item)" slot="activator" color="primary">
                                <v-icon dark>delete</v-icon>
                            </v-btn>
                            <span>Eliminar</span>
                        </v-tooltip>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    No se han encontrado resultados para "{{ search }}".
                </v-alert>
            </v-data-table>
        </v-form>
    </v-container>
</template>
<script>

    import DangerousProcess from "../../../model/DangerousProcess";

    export default {
        props: ['company'],
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                jobs:[],
                dialogSuccess:false,
                itemsPeligrosos: ['1', '2','3','4','5','6','7','8','9'],
                peligroso:new DangerousProcess(),
                peligrosos:[],
                itemsElements: [],
                headersPeligroso: [
                    { text: 'Puesto de trabajo', value: 'code' },
                    { text: 'Tipo', value: 'type' },
                    { text: 'Elemento', value: 'element' },
                    { text: 'Valor', value: 'value' },
                    { text: 'Fecha', value: 'date' },
                    { text: 'Acciones', value: 'editar' },
                ],
            };
        },
        methods: {
            getColor(item){
                if(item=="1" || item=="2" || item=="3"){
                    return "background-color: greenyellow"
                }else if(item=="4" || item=="5" || item=="6"){
                    return "background-color: #FFA420"
                }else{
                    return "background-color: red"
                }
            },
            getElementsByType(){
                this.$store.dispatch('getElementsByType',this.peligroso.type.id).then(response => {
                    this.itemsElements = this.$store.state.elements
                }, error => {
                    this.$store.state.progress = false
                    this.$store.state.dialogError = true
                })
            },
            saveDataPeligroso(){
                let today = new Date();
                let dd = String(today.getDate()).padStart(2, '0');
                let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                let yyyy = today.getFullYear();

                today = yyyy + '-'+ mm + '-' + dd ;
                this.peligroso.date = today
                if (this.checkNotEqual()){
                    this.$store.state.dialogErrorMessage = "Registro ya encontrado."
                    this.$store.state.progress = false
                    this.$store.state.dialogError = true
                }else{
                    if(this.peligroso.companyJob!="" && this.peligroso.type!="" && this.peligroso.element!="" && this.peligroso.value!="") {
                        this.$store.state.company = this.peligroso.companyJob.company
                        this.peligroso.company = this.peligroso.companyJob.company
                        this.$store.dispatch('addDangerousProcess',this.peligroso).then(response => {
                            this.peligrosos = this.$store.state.dangerousProcesses
                            this.peligroso=new DangerousProcess();
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }else{
                        this.$store.state.dialogErrorMessage = "Debe llenar todos los campos para poder agregar un nuevo registro."
                        this.$store.state.progress = false
                        this.$store.state.dialogError = true
                    }
                }

            },
            checkNotEqual(){
                if(this.$store.state.dangerousProcesses.length>0){
                    for(let i=0;i<this.$store.state.dangerousProcesses.length;i++){
                        if(this.$store.state.dangerousProcesses[i].companyJob.id==this.peligroso.companyJob.id && this.$store.state.dangerousProcesses[i].type.id==this.peligroso.type.id && this.$store.state.dangerousProcesses[i].element.id==this.peligroso.element.id && this.$store.state.dangerousProcesses[i].value==this.peligroso.value && this.$store.state.dangerousProcesses[i].date == this.peligroso.date){
                            return true
                        }
                    }
                }
                return false
            },
            deleteItemPeligroso(item) {
                const index = this.$store.state.dangerousProcesses.indexOf(item)
                this.peligroso = Object.assign({}, item)
                confirm('Está seguro de que quiere eliminar el registro?') &&  this.$store.dispatch('deleteDangerousProcess', this.peligroso.id)
            },
        },
        computed: {}
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/company/matrizProcesosPeligrosos/MatrizProcesosPeligrosos.vue